import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {fetchProfileData} from "../../../../entities/Profile/model/fetchProfileDate/fetchProfileDate";
import {registerActions} from "../../slice/registerSlice";
import {USER_LOCALSTORAGE_KEY, USER_SUCCESS_KEY} from "shared/const/localstorage";
import {userActions} from "entities/User/model/slice/userSlice";
import {accountUserActions} from "app/accountLoginSlice";

export interface IRegisterByUserProps {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    password: string;
    retypePassword: string;
    privacyAccept: boolean;
    promoCode: string;
    website: string;
}

export const registerByUser = createAsyncThunk<void, IRegisterByUserProps>(
    'register/registerByUser',
    async (registerData, thunkAPI) => {
        try {
            const response = await axios.post('/api/registration', registerData);
            if (!response.data) {
                throw new Error("Response data is empty.");
            }
            if (response.data.success) {
                localStorage.setItem(USER_LOCALSTORAGE_KEY, JSON.stringify(response.data.data));
                localStorage.setItem(USER_SUCCESS_KEY, JSON.stringify(response.data.success));
                thunkAPI.dispatch(userActions.initAuthData(response.data.success));
                await thunkAPI.dispatch(fetchProfileData());
            }
            thunkAPI.dispatch(registerActions.setRegisterData(response.data));
            thunkAPI.dispatch(accountUserActions.accountUser(response.data));
        } catch (e) {
            console.error("Registration error:", e);
            throw e;
        }
    }
);

